import { BecomeAmbassadorMolecule } from '../../molecules';
import { AmbassadorContentHero, Route } from '../../../enums';
import LazyLoad from 'react-lazyload';

export const AmbassadorDesktopHeroOrganism = () => {
  return (
    <div className="py-7 flex flex-row justify-start block">
      <div className="w-7/20 -ml-2/25">
        <LazyLoad offset={100}>
          <img
            src="/images/ambassadors/desktop/hero/main_hero_ambassador_doctor.png"
            className="w-full"
          />
        </LazyLoad>
      </div>

      <div className="w-12/25 flex items-center pb-20">
        <div className="ml-1/5">
          <h2 className="text-4xl	 leading-10 max-w-80">
            {AmbassadorContentHero.HERO_TITLE}
          </h2>
          <p className="mt-4   w-3/4 text-lg leading-6 py-4">
            {AmbassadorContentHero.HERO_CONTENT}
          </p>
          <div className="min-w-max w-4/5 pr-10 mt-6">
            <BecomeAmbassadorMolecule
              href={Route.JOIN}
              label={AmbassadorContentHero.HERO_CTA}
            />
          </div>
        </div>
      </div>
      <div className="w-19/50 -mr-2/25">
        <div className="w-full flex justify-end flex-row">
          <div className="w-9/20">
            <LazyLoad offset={100} height={490}>
              <img
                src="/images/ambassadors/desktop/hero/AdobeStock_451902208.png"
                className="flex place-items-end"
              />
            </LazyLoad>
          </div>
        </div>
        <div className="w-9/20 mt-10">
          <LazyLoad offset={100} height={100}>
            <img
              src="/images/ambassadors/desktop/hero/AdobeStock_271209573.png"
              className="flex place-items-end"
            />
          </LazyLoad>
        </div>
      </div>
    </div>
  );
};
